module.exports = __webpack_public_path__ + "img/end-screen.03a1ebb5.svg";